import { ArtAssetFormat } from '@do/models';
import type { ValuesOf } from '@do/utils/types';

import type { IconNames } from '@shared/ui/icon';

export const FormatLabel = {
  [ArtAssetFormat.Image]: 'Still Image',
  [ArtAssetFormat['3Dobject']]: '3D Object',
  [ArtAssetFormat.MotionArt]: 'Animation',
  [ArtAssetFormat.Json]: 'Generative',
} as const;

export type FormatLabel = ValuesOf<typeof FormatLabel>;

export type FormatOption = {
  value: ArtAssetFormat;
  text: FormatLabel;
  icon?: IconNames;
};

export const formatOptions: FormatOption[] = [
  { value: ArtAssetFormat.Image, text: FormatLabel[ArtAssetFormat.Image] },
  { value: ArtAssetFormat['3Dobject'], text: FormatLabel[ArtAssetFormat['3Dobject']], icon: 'cube' },
  { value: ArtAssetFormat.MotionArt, text: FormatLabel[ArtAssetFormat.MotionArt], icon: 'play' },
  { value: ArtAssetFormat.Json, text: FormatLabel[ArtAssetFormat.Json], icon: 'code' },
];
